import { COMPANY_HISTORY_CATEGORIES } from '@model';

export const filterData = (data = [], filters = {}) => {
  const filterKeys = Object.keys(filters);
  if (data.length === 0 || Object.keys(filterKeys).length === 0) {
    return data;
  }

  const r = filterKeys.reduce(
    (result, key) => {
      const filterValue = filters[key];
      let newResult = result;

      if (typeof filterValue !== 'object') {
        newResult = newResult.filter((res) => res[key] === filterValue);
      } else if (Array.isArray(filterValue)) {
        newResult = newResult.filter((res) => filterValue.includes(res[key]));
      }

      return newResult;
    },
    [...data],
  );
  return r;
};

export const getYearOptions = (years = []) =>
  years.map((year) => ({ value: year, label: year }));

export const getCateOptions = (cate = [], l = {}) =>
  cate
    .sort((a, b) => Number(a) - Number(b))
    .map((cateId) => ({
      label: `${COMPANY_HISTORY_CATEGORIES[cateId - 1]}(${l[cateId]})`,
      value: cateId,
    }));

export const getYearsCateValue = ({ years = [], categories = {} }) => {
  const res = Array.from(
    new Set(
      years.reduce(
        (result, year) => [...result, ...(categories[year] || [])],
        [],
      ),
    ),
  );
  return res;
};

export const getYearsCateLength = ({
  years = [],
  categories = {},
  yearsWithCateId = {},
}) => {
  const cates = getYearsCateValue({ years, categories });

  const res = cates.reduce((result, cate) => {
    years.forEach((y) => {
      Object.keys(yearsWithCateId).forEach((c) => {
        if (c === y && yearsWithCateId[y].includes(cate)) {
          const l = yearsWithCateId[y].filter((c) => c === cate);
          if (!result[cate]) {
            result[cate] = l.length;
          } else {
            result[cate] = result[cate] + l.length;
          }
        }
      });
    });

    return result;
  }, {});
  return res;
};

export const getYearsCateOptions = ({
  years = [],
  categories = {},
  yearsWithCateId = {},
}) =>
  getCateOptions(
    Array.from(getYearsCateValue({ years, categories })),
    getYearsCateLength({ years, categories, yearsWithCateId }),
  );
